import React, { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { Formik, Form as FormikForm } from "formik";
import * as Yup from "yup";
import { Card, Button, Form } from "react-bootstrap";

import {
  resetRecordarContrasenaAction,
  recordarContrasenaAction,
} from "../../redux/actions/recordarContrasenaActions";

import Logo from "../Layout/Logo";

import "./style.css";

import Swal from "sweetalert2";
import Alert from "../Utilidades/Alert";

const RecordarContrasenaForm = ({ handlerLogin }) => {
  const dispatch = useDispatch();
  const [usuario, setUsuario] = useState("");
  const formikRef = useRef(null);

  // Acceder al state del store

  const { loading, error, resultado, errorMessage } = useSelector(
    (state) => state.recordarcontrasena
  );

  const usuarioDefault = {
    usuario: "",
  };

  const recordarSchema = Yup.object().shape({
    usuario: Yup.string()
      .email("Introduzca un Email válido")
      .required("Requerido"),
  });

  // mandar llamar el action de participanteAction
  const recordarContrasena = (credenciales) => {
    dispatch(recordarContrasenaAction(credenciales));
  };

  // Se ejecuta al destruir el componente
  useEffect(() => {
    return () => {
      dispatch(resetRecordarContrasenaAction());
    };
  }, [dispatch]);

  useEffect(() => {
    if (!loading && !error && resultado && resultado?.resultado) {
      resetForm();
      dispatch(resetRecordarContrasenaAction());
      Swal.fire({
        icon: "success",
        title: resultado?.msg,
        showConfirmButton: false,
        timer: 2500,
      });
    }
  }, [loading, error, resultado, dispatch]);

  const resetForm = () => {
    setUsuario("");
  };

  return (
    <div
      className="hold-transition login-page login-page-background"
    >
      <Card className="login-box">
        <Card.Header
          style={{ backgroundColor: "transparent", borderBottom: "none" }}
        >
          <Logo className="mt-5 mb-3" />
        </Card.Header>
        <Card.Body>
          <Card.Text className="text-center">Recuperar Contraseña</Card.Text>

          <Formik
            innerRef={formikRef}
            initialValues={usuarioDefault}
            validationSchema={recordarSchema}
            onSubmit={(values, actions) => {
              recordarContrasena(values);
            }}
          >
            {({ errors, touched, handleChange }) => (
              <FormikForm>
                <Form.Group className="mb-2">
                  <Card.Text className="fw-bold">Email</Card.Text>
                  <Form.Control
                    id="usuario"
                    name="usuario"
                    type="email"
                    value={usuario}
                    onChange={(e) => {
                      handleChange(e);
                      setUsuario(e.target.value);
                    }}
                    placeholder="Ingrese Email"
                    isInvalid={touched.usuario && !!errors.usuario}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.usuario}
                  </Form.Control.Feedback>
                </Form.Group>
              </FormikForm>
            )}
          </Formik>
          <Link to={"/"}>Regresar</Link>
        </Card.Body>
        <Card.Footer
          style={{ backgroundColor: "transparent", borderTop: "none" }}
        >
          <Button
            variant="success"
            className="btn-sm"
            onClick={() => {
              formikRef.current?.submitForm();
            }}
            disabled={loading}
          >
            {loading ? (
              <>
                <span
                  className="spinner-border spinner-border-sm me-2"
                  role="status"
                  aria-hidden="true"
                ></span>
                Enviando...
              </>
            ) : (
              "Enviar"
            )}
          </Button>
          {!loading && error && (
            <Alert variant={"danger"} message={errorMessage} />
          )}
        </Card.Footer>
      </Card>
    </div>
  );
};

export default RecordarContrasenaForm;
